module.exports = __webpack_public_path__ + "img/leavy-icon-default.09bf4a93.svg";